import { render, staticRenderFns } from "./ExamMassSchedulingTable.vue?vue&type=template&id=35854b1e"
import script from "./ExamMassSchedulingTable.vue?vue&type=script&lang=js"
export * from "./ExamMassSchedulingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports